import { createContext } from 'react';

import type { DemandCalculation } from '../types/DemandCalculation';
import type { DemandFleetCompany } from '../types/DemandFleetCompany';
import type { DemandProductCategoryOption } from '../types/DemandProductCategoryOption';

interface DemandDefinitionCalculationContextValue {
    calculation?: DemandCalculation;
    retainedCalculation?: DemandCalculation;
    retryCalculation: () => void;
    categories: DemandProductCategoryOption[];
    companies: DemandFleetCompany[];
    isCalculationError: boolean;
    isCalculationFetching: boolean;
    isCalculationLoading: boolean;
    isCompanyVolumeLoading: boolean;
    isCalculationPending: boolean;
    showHistoricalData: boolean;
}

export const DemandDefinitionCalculationContext = createContext<DemandDefinitionCalculationContextValue | undefined>(
    undefined
);
